<script>
import { Article, ArticleCategory, ArticleTag } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import moment from 'moment'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        widgets: [],
        side_infos: [],
        tags: []
      },
      categoryOptions: [],
      tagOptions: [],
      redirectRoute: { name: 'Article List' }
    }
  },
  created() {
    this.fetchCategories()
    this.fetchTags()
  },
  methods: {
    fetchCategories() {
      const params = { page_size: 'max' }
      ArticleCategory.fetch({}, { params }).then(res => {
        this.categoryOptions = res.data.results.map(item => {
          return { label: item.title_pl, value: item.id }
        })
      })
    },
    fetchTags() {
      const params = { page_size: 'max' }
      ArticleTag.fetch({}, { params }).then(res => {
        this.tagOptions = res.data.results.map(item => ({
          label: item.name_pl,
          value: item.id
        }))
      })
    },
    getSidebarFields() {
      return [
        new fields.Header({
          type: 'h4',
          text: 'Data utworzenia'
        }),
        new fields.Date({
          type: 'datetime',
          modelPath: [this, 'form', 'created']
        }),
        new fields.Header({
          text: this.publicationInFutureMessage,
          type: 'p',
          condition: this.publicationInFuture
        }),
        new fields.Header({
          type: 'h4',
          text: 'Data modyfikacji'
        }),
        new fields.Date({
          type: 'datetime',
          modelPath: [this, 'form', 'modified'],
          disabled: true
        })
      ]
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            this.getGeneralTab(),
            this.getWidgetsTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Tytuł (wielkość fonta w %)',
            modelPath: [this, 'form', 'title_font_size'],
            clearable: true,
            type: 'number'
          }),
          new fields.Select({
            label: 'Kategoria',
            modelPath: [this, 'form', 'category'],
            options: this.categoryOptions
          }),
          new fields.Select({
            label: 'Tagi',
            modelPath: [this, 'form', 'tags'],
            multiple: true,
            options: this.tagOptions
          }),
          new fields.Input({
            label: 'Lead',
            modelPath: [this, 'form', 'lead'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie',
            modelPath: [this, 'form', 'image']
          }),
          new fields.Video({
            label: 'Wideo',
            modelPath: [this, 'form', 'video']
          }),
          new fields.Attachment({
            label: 'PDF',
            modelPath: [this, 'form', 'pdf'],
            multilingual: true
          }),
          new fields.Switch({
            label: 'Portretowe zdjęcie',
            modelPath: [this, 'form', 'is_image_portrait']
          }),
          new fields.Switch({
            label: 'Na stronie głównej',
            modelPath: [this, 'form', 'is_home']
          }),
          new fields.Switch({
            label: 'Artykuł z ograniczonym dostępem',
            modelPath: [this, 'form', 'is_limited_access']
          }),
          new fields.Switch({
            label: 'Artykuł skondensowany',
            modelPath: [this, 'form', 'is_condensed_content']
          }),
          new fields.Header({
            type: 'h3',
            text: 'Informacje poboczne'
          }),
          this.getSideInfosFormset()
        ]
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          })
        ]
      }
    },
    getSideInfosFormset() {
      return new fields.Formset({
        modelPath: [this, 'form', 'side_infos'],
        items: this.form.side_infos.map((sideInfoItem, sideInfoIndex) => {
          return {
            headerLabel: sideInfoItem.title_pl,
            fields: [
              new fields.Input({
                label: 'Tytuł',
                // prettier-ignore
                modelPath: [this, 'form', 'side_infos', sideInfoIndex, 'title'],
                multilingual: true,
                required: true
              }),
              new fields.Input({
                label: 'Treść',
                // prettier-ignore
                modelPath: [this, 'form', 'side_infos', sideInfoIndex, 'content'],
                multilingual: true,
                required: true
              })
            ]
          }
        })
      })
    }
  },
  computed: {
    publicationInFutureMessage() {
      if (!this.publicationInFuture) {
        return ''
      }
      const givenDate = moment(this.form.created)
      return `Artykuł będzie dostępny dla użytkowników
           ${givenDate.format('DD/MM/YYYY')}
           o godzinie. ${givenDate.format('HH:mm')}`
    },
    publicationInFuture() {
      if (!this.form.created) {
        return false
      }
      return moment().isBefore(this.form.created)
    },
    service() {
      return Article
    },
    formCreatedDate() {
      return this.form.created
    }
  },
  watch: {
    formCreatedDate() {
      this.form.is_hidden = this.publicationInFuture
    }
  }
}
</script>
